// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"0dcd0efe","839":"f366f527","878":"f366f527","890":"b3047518","910":"2cdffe4a"}[chunkId] + ".chunk.css";
};